import { getAdvertiserRuleSASuggestions } from 'app/sponsoredAds/services/autosuggestServices';
import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

export default withAutosuggestWrapper(withInputErrorMessage(autosuggestFactory({
   apiPromise: getAdvertiserRuleSASuggestions,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabel,
   defaultPlaceholder: 'Search Advertiser Rule...',
})));
